// language.js
import cookies from "../plugins/cookies";
import { ref, computed } from 'vue'
import fr from './fr'
import en from './en'

// Available Languages
const availableLanguages = [
    {
        code: 'fr',
        name: 'Français',
        file: fr,
        locale: "fr-FR"
    },
    {
        code: 'en',
        name: 'English',
        file: en,
        locale: "en-EN"
    }
]

// Current Language Code
const currentLanguageCode = ref('fr')

// Current Language File
const t = computed(
    () => {
        var result;
        try {
            result = availableLanguages.find((lang) => lang.code === currentLanguageCode.value).file
        } catch (error) {
            setLanguage()
            result = availableLanguages.find((lang) => lang.code === currentLanguageCode.value).file
        }

        return result
    }
)

// Set Language
const setLanguage = (code = 'fr') => {
    currentLanguageCode.value = code
    cookies.set('language', code)
}

const getLanguage = () => {
    return cookies.get('language');
}

const getLocale = () => {
    return availableLanguages.find((lang) => lang.code === currentLanguageCode.value).locale;
}

export {
    availableLanguages,
    currentLanguageCode,
    t,
    setLanguage,
    getLanguage,
    getLocale
}